import {defineComponent, PropType, shallowRef, watch} from "vue";
import {useDefaultSlot} from "../util";

const dragging = shallowRef(false);
window.document.addEventListener("dragstart", () => {
  setTimeout(() => (dragging.value = true));
});

window.document.addEventListener("dragend", () => (dragging.value = false));

/**
 *
 */
export default defineComponent({
  name: "ScDrop",
  props: {
    accept: {
      type: [Array, String] as PropType<
        string | string[] | ((type: string) => boolean)
      >,
    },
    modelValue: Boolean,
  },
  emits: ["drop", "update:modelValue"],
  setup(props, context) {
    // 当前绑定的对象
    const { el, getRenderFn } = useDefaultSlot(context.slots);
    const hover = shallowRef(0);

    const isAccept = (types: readonly string[]) => {
      if (!props.accept) {
        return types[0];
      }
      const accept =
        props.accept instanceof Array ? props.accept : [props.accept];
      return types.find((type) => accept.find((accept) => accept === type));
    };
    const dragoverListener = (ev: DragEvent) => {
      if (ev.dataTransfer && isAccept(ev.dataTransfer.types)) {
        ev.preventDefault();
      }
    };
    const dragenterListener = (ev: DragEvent) => {
      if (ev.dataTransfer && isAccept(ev.dataTransfer.types)) {
        hover.value += 1;
        ev.preventDefault();
      }
    };
    const dragleaveListener = () => {
      hover.value -= 1;
    };
    const dropListener = (ev: DragEvent) => {
      hover.value = 0;
      if (ev.dataTransfer) {
        const format = isAccept(ev.dataTransfer.types);
        if (format) {
          context.emit("drop", {
            format,
            data: ev.dataTransfer.getData(format),
          });
        }
      }
    };
    watch(hover, () => {
      context.emit("update:modelValue", hover.value > 0);
    });
    watch(el, (el, preEl) => {
      if (preEl) {
        preEl.removeEventListener("dragover", dragoverListener);
        preEl.removeEventListener("dragenter", dragenterListener);
        preEl.removeEventListener("dragleave", dragleaveListener);
        preEl.removeEventListener("drop", dropListener);
      }
      if (el) {
        el.addEventListener("dragover", dragoverListener);
        el.addEventListener("dragenter", dragenterListener);
        el.addEventListener("dragleave", dragleaveListener);
        el.addEventListener("drop", dropListener);
      }
    });
    return getRenderFn(() => {
      return {
        hover: hover.value > 0,
        dragging: dragging.value,
      };
    });
  },
});
